










































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { InstituteInfo } from "../../_models/instituteInfo";

@Component
export default class DetailsInstituteInfoTab extends Vue{
    @Prop() info!: InstituteInfo;

    // private ragioneSocialeIstituto: string;
    // private indirizzoIstituto: string;
    // private capComuneIstituto: string;
    // private nazioneIstituto: string;
    // private comuneIstituto: string;
    // private telefono1Istituto: string;
    // private telefono2Istituto: string;
    // private emailIstituto: string;
    // private pecIstituto: string;
    // private codIstituto: string;
    // private codMinisterialeIstituto: string;

    // constructor(){
    //     super();
    //     this.ragioneSocialeIstituto = this.info.ragioneSocialeIstituto;
    //     this.indirizzoIstituto = this.info.indirizzoIstituto;
    //     this.capComuneIstituto = this.info.capComuneIstituto;
    //     this.nazioneIstituto = this.info.nazioneIstituto;
    //     this.comuneIstituto = this.info.comuneIstituto;
    //     this.telefono1Istituto = this.info.telefono1Istituto;
    //     this.telefono2Istituto = this.info.telefono2Istituto;
    //     this.emailIstituto = this.info.emailIstituto;
    //     this.pecIstituto = this.info.pecIstituto;
    //     this.codIstituto = this.info.codIstituto;
    //     this.codMinisterialeIstituto = this.info.codMinisterialeIstituto;
    // }
}
